import { useState } from "react";
import { useTranslation } from "react-i18next";
import Accordion from "../../../components/accordian";
import { Controller } from "react-hook-form";
import TextInput from "../../../components/inputs/TextInput";
import RequestedServicesCard from "./RequestedServicesCard";

interface RequestDetailsProps {
    control: any;
    errors: any;

    isFieldsDisabled: boolean;

    requestedServicesIds: number[]
    setRequestedServicesIds: React.Dispatch<React.SetStateAction<number[]>>;
}

const RequestDetails = ({
    control,
    errors,
    isFieldsDisabled,
    requestedServicesIds,
    setRequestedServicesIds
}: RequestDetailsProps) => {
    const { t } = useTranslation();

    const [selectedKey, setSelectedKey] = useState<string>("1");

    return (
        <div className="bg-white z-10 p-2 md:p-4 rounded-xl flex flex-col gap-3 lg:gap-6 shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
            <Accordion
                id="1"
                selectedKey={selectedKey}
                onSelectionChange={setSelectedKey}
                title={
                    <h1 className="text-xl md:text-2xl flex flex-1 -mt-2 items-center">
                        {t("2")}. {t("requestDetails")}
                    </h1>
                }
            >
                <div className="flex flex-col gap-4 lg:gap-6">
                    <RequestedServicesCard
                        requestedServicesIds={requestedServicesIds}
                        setRequestedServicesIds={setRequestedServicesIds}
                        isFieldsDisabled={isFieldsDisabled}
                    />

                    <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 lg:gap-4">
                        <Controller
                            name="officeNumber"
                            control={control}
                            render={({ field: { onChange, name, value } }) => (
                                <TextInput
                                    label={t("officeNumber")}
                                    value={value}
                                    onChange={onChange}
                                    error={errors?.[name]?.message}
                                    required
                                    readOnly={isFieldsDisabled}
                                />
                            )}
                        />
                    </div>
                </div>
            </Accordion>
        </div>
    )
}

export default RequestDetails
